
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { AccountDetailDrilldownViewModel, ActivityDetail, EncumbranceDetail, ReserveDetail } from "@tylertech/tyler-api-types";

/**
 * AccountDetailDrilldownService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class AccountDetailDrilldownService {
    constructor(private readonly $apiService: ApiService) { }
    
    GetActivity(fetch: AccountDetailDrilldownViewModel): Promise<ActivityDetail[]> {
        return this.$apiService.sendAuth("IAccountDetailDrilldownService/GetActivity", fetch);
    }
    GetEncumbrance(fetch: AccountDetailDrilldownViewModel): Promise<EncumbranceDetail[]> {
        return this.$apiService.sendAuth("IAccountDetailDrilldownService/GetEncumbrance", fetch);
    }
    GetReserve(fetch: AccountDetailDrilldownViewModel): Promise<ReserveDetail[]> {
        return this.$apiService.sendAuth("IAccountDetailDrilldownService/GetReserve", fetch);
    }
}
